import {FC} from 'react'
import {Button, Col, Container, Image, Row} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import Error500Image from '../../../../assets/img/500.png'

const Error500: FC = () => {
  const navigate = useNavigate()
  return (
    <Container
      fluid
      className='d-flex flex-column justify-content-center align-items-center text-center min-vh-100'
      style={{padding: '2rem', backgroundColor: '#FFF'}}
    >
      <Row className='justify-content-center'>
        <Col md={24} lg={24}>
          {/* Gambar ilustrasi */}
          <Image
            src={Error500Image}
            alt='500 Internal Server Error'
            style={{
              width: '80%',
              height: 'auto',
            }}
            className='mb-4'
          />

          {/* Judul */}
          <h2 className='mb-3 my-4' style={{textTransform: 'none', color: '#1C3177'}}>
            Ups, Terjadi kesalahan teknis !
          </h2>

          {/* Deskripsi */}
          <p className='my-4'>
            Maaf, tampaknya server kami sedang mengalami masalah. Tim kami sedang berusaha
            memperbaikinya. (500)
          </p>

          {/* Tombol kembali */}
          <Button
            className='btn btn-primary btn-sm mt-3 px-4'
            style={{
              background: 'var(--Primary-L-500, #F95E2F)',
              borderRadius: '50px',
              border: 'none',
            }}
            onClick={() => navigate(-1)}
          >
            Kembali ke halaman sebelumnya
          </Button>
        </Col>
      </Row>
    </Container>
  )
}

export {Error500}
